<template>
  <AdminLayout :title="$t('admin_site.site_title')" :current="$c.ADMIN.TAB.SITE">
    <div class="section">
      <div class="container" align=center style="width: 90%">
        <div style="height: 58px;" class="center">
          <div class="pagination">
            <div @click="onMonth(-1)" class="page_btn">&lt;&lt;&nbsp; </div>
            <div @click="onDay(-1)" class="page_btn">&lt;&nbsp; </div>
            <div class="date">{{this.date.format('M월 D일')}}</div>
            <div @click="onDay(1)" class="page_btn">&gt;&nbsp;</div>
            <div @click="onMonth(1)" class="page_btn">&gt;&gt;&nbsp;</div>
          </div>
        </div>

        <b-tabs v-model="activeTab" fill style="width: 100%;">
          <b-tab title="삭제" active title-link-class="tab_text tab"></b-tab>
          <b-tab title="숨김"  title-link-class="tab_text tab"></b-tab>
          <b-tab title="분양완료"  title-link-class="tab_text tab"></b-tab>
        </b-tabs>

        <div class="container scroll" @scroll="onScroll" ref="wrap" style="width: 480px; padding-top: 4em;padding-bottom: 6em; overflow: auto;height: 100vh;">
          <SiteItem v-for="item in list"
                    :item="item"
                    :isAdmin="true"
                    :showAdminBtn="activeTabName"
                    @remove="onRemove"
          />
        </div>
      </div>
    </div>

    
  </AdminLayout>
</template>
<script>

import SiteItem from "../../../controls/SiteItem";
import AdminLayout from './controls/adminlayout'
import Utils from "../../../../config/utils";
import moment from "moment";

const $u = require('util');

const TAB = {
  DELETE: 'D',
  HIDDEN: 'H',
  COMPLETE: 'C',
};

export default {
  name: "AdminSite",
  components: {
    AdminLayout,
    SiteItem,
  },
  data() {
    return {
      moment:moment,
      date: moment(),
      activeTab: 0,
      list: [],
      loadingEnd: false,
      pageNum: 1,
      isLoad: false,
    }
  },
  methods:{
    onScroll(){
    },
    initList(tab){
        this.list = [];
        this.loadingEnd = false;
        this.pageNum = 1;
        this.activeTab = tab;
        this.getList();
    },
    getList(){
      if (this.loadingEnd || this.isLoad) {
        return;
      }

      this.isLoad = true;

      Utils.requestGet(
        this.$c.API.Site.findSiteByStatus,
        {
          type: this.activeTabName,
          page_num: this.pageNum,
          date: this.date.format('YYYY-MM-DD')
        },
      ).then(result => {
        this.isLoad = false;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
           this.list = this.list.concat(result.data.list);
          this.loadingEnd = result.data.list.length < result.data.limit;
           this.pageNum = ++this.pageNum;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onDay(day){
      this.date = this.date.clone().add(day, 'day')
      this.initList(this.activeTab);
    },

    onMonth(month) {
      this.date = this.date.clone().add(month, 'month')
      this.initList(this.activeTab);
    },
    onRemove(idx) {
      Utils.setState(this,{
        list: this.list.filter(it => {
          return it.f_idx != idx;
        }),
      });
    },
  },
  computed:{
    activeTabName(){
      switch (this.activeTab){
        case 0: return TAB.DELETE;
        case 1: return TAB.HIDDEN;
        case 2: return TAB.COMPLETE;
      }
    }
  },
  watch:{
    activeTab(){
      this.initList(this.activeTab);
    }
  },
  mounted() {
    moment.locale('ko');
    this.initList(this.activeTab);
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';

.tab-item {
  color:black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.md_active{
  color:$primary!important;
  border-bottom: solid 3px $primary;
}

.center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination{
  @extend .center;
  height: 50px;
}

.page_btn{
  @extend .center;
  width: 50px;
  height: 25px;
  color: #919191;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
  cursor: pointer;
}

.date{
  color: $black;
  font-size: $fs_20;
  padding:0 5px;
  font-family: $korean_gd_16_r
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminSite.vue